import { createFileRoute } from "@tanstack/react-router"

import { ProjectMapLayout } from "../../../../../../layouts/ProjectMapLayout"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap")({
	component: ProjectMapLayout,
})
